import { LocationTranslate } from './locationTranslate.model';

const locationTranslateEN: LocationTranslate = {
  combobox: {
    triggerAriaLabel: 'Select location',
    placeholder: 'Location',
    searchPlaceholder: 'Search location...',
    loading: 'Loading locations...',
    empty: 'No location found',
    clear: 'Remove location',
    createNew: 'Add a new location',
    createNamed: 'Add "{{name}}"',
    createTitle: 'New location',
    editTitle: 'Edit location',
    editAriaLabel: 'Edit location {{name}}',
    namePlaceholder: 'Location name',
    addressToggle: 'Address (optional)',
    cancel: 'Cancel',
    confirm: 'Add',
    save: 'Save',
    delete: 'Delete',
    confirmDelete: 'Confirm deletion',
  },
  toast: {
    created: 'Location added successfully',
    updated: 'Location updated successfully',
    deleted: 'Location deleted successfully',
    error: {
      create: 'Could not add the location',
      update: 'Could not update the location',
      delete: 'Could not delete the location',
    },
  },
};

export default locationTranslateEN;
